import React from 'react';
import { string, oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  /** Html element. */
  tag: string,
  /** Gutter size */
  gutters: oneOf(['condensed']),
};

const CLASS_ROOT = 'grid';

const Grid = ({ className, tag = 'div', gutters, ...other }) => {
  const classes = cx(CLASS_ROOT, className, {
    [`${CLASS_ROOT}--${gutters}`]: gutters,
  });
  const TagName = tag;

  return <TagName className={classes} {...other} />;
};

Grid.displayName = 'Grid';
Grid.propTypes = propTypes;

export default Grid;



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js